export default __webpack_public_path__ + "static/media/Banner5.e7ced562.png";